// extracted by mini-css-extract-plugin
export default {"container":"GGS_container__Dloib","text":"GGS_text__ObF-3","listBlock":"GGS_listBlock__SGhAN"};